(function () {
  function deepMerge(source, overwriter) {
    if (typeof source !== "object" || source === null) {
      return overwriter !== undefined ? overwriter : source;
    }
    if (Array.isArray(source)) {
      return source.map((item, index) => deepMerge(item, overwriter[index]));
    }
    const result = {};
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        result[key] = deepMerge(source[key], overwriter?.[key]);
      }
    }
    return result;
  }

  const translated = {
    settings: {
      cart_empty: {
        cart_empty_title: "YOUR SHOPPING BASKET IS EMPTY",
        cart_empty_subtitle: "Add your desired items to the shopping cart",
        cart_empty_button_text: "Shop now",
        cart_empty_upsell_heading: "You might like it too:",
      },
      countdown: {
        countdown_text:
          "🔥 Your cart is reserved for {{time_remaining}} minutes!",
        countdown_text_expire: "Cart reservation expired.",
      },
      announcement_tiers: [
        {
          announcement_text:
            "Free shipping in AT/DE from € 100 and within the EU from € 150.",
        },
      ],
      rewards_all_countries_tiers: [
        {
          rewards_title: "You are {{ price }} away from free shipping!",
          rewards_congratulations:
            "🍍 Congrats! you have unlocked free shipping!",
        },
      ],
      rewards_specific_countries_tiers: [
        {
          rewards_title_specific_countries:
            "Only {{ price }} until free shipping!",
          rewards_congratulations_specific_countries:
            "Congratulations! Your order will be delivered to you for free!",
        },
        {
          rewards_title_specific_countries:
            "Only {{ price }} until free shipping!",
          rewards_congratulations_specific_countries:
            "Congratulations! Your order will be delivered to you for free!",
        },
        {
          rewards_title_specific_countries:
            "Only {{ price }} until free shipping!",
          rewards_congratulations_specific_countries:
            "Congratulations! Your order will be delivered to you for free!",
        },
        {
          rewards_title_specific_countries:
            "Only {{ price }} until free shipping!",
          rewards_congratulations_specific_countries:
            "Congratulations! Your order will be delivered to you for free!",
        },
      ],
      product_recommendations_settings: {
        section_heading_products: "Frequently bought together:",
      },
      manually_products_upsells: {
        section_heading_products_manually: "Add-Ons",
      },
      static_products_upsells: {
        section_heading_products_static: "You Might Also Like These:",
      },
      tiered_free_items: {
        tfi_section_heading: "FREE GIFT WITH YOUR PURCHASE",
        tfi_unlock_text: "Unlock to {{amount}}",
      },
      special_offer_notification_tier: [
        {
          special_offer_message_qualify:
            "Congratulations, You've qualified for free shipping.",
          special_offer_message_not_qualify:
            "Almost there, Add {{ remaining_amount }} more to get free shipping.",
          tier_name: "Tier 1",
        },
      ],
      minimum_order: {
        minimum_order_text: "Minimum Order {{ money }}",
      },
      cart_coupon: {
        name_cart_coupon_button: "Add",
        placeholder_cart_coupon_button: "Discount Code",
      },
      cart_note: {
        cart_note_heading: "Add an optional note",
        cart_note_heading_close: "Close optional note",
        cart_note_heading_placeholder: "Special instructions",
        cart_note_additional_text: "Receive Gift",
        cart_note_additional_message: "Accept gift",
      },
      language_settings: {
        cart_title_language_settings: "Your Cart",
        cart_empty_text_language_settings: "Your Cart is Empty",
        add_to_cart_language_settings: "ADD",
        add_in_upsell_language_settings: "ADD",
        rc_withOutSub_in_upsell_language_settings: "One Time",
        rc_withSub_in_upsell_language_settings: "Subscribe & Save",
        shopping_cart_language_settings: "Your Cart",
        product_language_settings: "Product",
        products_language_settings: "Products",
        subtotal_language_settings: "Total",
        clear_all_language_settings: "Remove Everything",
        remove_language_settings: "Remove",
        sold_out_language_settings: "Sold Out",
        unavailable_language_settings: "Not Available",
        free_language_settings: "Free",
        free_gnral_language_settings: "",
        add_discount_code_language_settings: "Enter discount code",
        discount_applied_language_settings: "Discount of {{ money }} applied",
        checkout_button_textlanguage_settings: "CHECKOUT",
        vendor_key_text_language_settings: "Vendor",
        subscription_text_language_settings: "Subscription",
        valid_coupon_text: "Please enter a valid code",
        shipping_taxes_discounts_language_settings: "",
      },
      gift_wrap: {
        offer_name: "Gift wrap",
        featured_product_title:
          "Your offer is {{ Product-title }} now available",
      },
      terms_conditions: {
        text_terms:
          "I have understood & agreed with your {{ terms & conditions }}.",
        notify_terms: "You must accept the terms and conditions\t",
      },
      checkout_button: {
        checkout_button_text: "Checkout",
      },
      cart_button: {
        cart_button_text: "Go to cart",
      },
      continue_shopping: {
        continue_shopping_text: "Continue Shopping",
      },
    },
    coupon_bar: {
      coupon_bar_text: "20% OFF Sale Ends {{ COUNTDOWN }} Code: TAKE20OFF",
      coupon_bar_text_expire: "Coupon expired",
      coupon_bar_hours: "hours",
      coupon_bar_minutes: "minutes",
      coupon_bar_seconds: "seconds",
    },
  };

  if (!window.HSSLIDECART) {
    window.HSSLIDECART = {};
  }

  let _setSettings;

  Object.defineProperty(window.HSSLIDECART, "setSettings", {
    configurable: true,
    enumerable: true,
    set(value) {
      if (value?.settings) {
        value.settings = deepMerge(value.settings, translated.settings);
      }
      _setSettings = value;
    },
    get() {
      return _setSettings;
    },
  });

  if (window.HSSLIDECART.setSettings) {
    _setSettings = window.HSSLIDECART.setSettings;
  }
})();
